import {
  useMutation,
  useQuery
} from "react-query";
import { studentApiRequest } from "./client";
var GoPeerUserType = /* @__PURE__ */ ((GoPeerUserType2) => {
  GoPeerUserType2["ENTERED_ASSESSMENT"] = "ENTERED_ASSESSMENT";
  GoPeerUserType2["EXITED_ASSESSMENT"] = "EXITED_ASSESSMENT";
  return GoPeerUserType2;
})(GoPeerUserType || {});
const fetchGoPeerToken = () => {
  return studentApiRequest({
    url: "/go-peer/token",
    method: "GET"
  });
};
const fetchGoPeerAvailability = (subject) => {
  return studentApiRequest({
    url: "/go-peer/availability",
    method: "GET",
    params: {
      subject
    }
  });
};
function useGoPeerTokenQuery() {
  return useQuery(["goPeerToken"], () => fetchGoPeerToken(), {
    useErrorBoundary: false
  });
}
const sendGoPeerUserEvent = (goPeerUserEvent) => {
  return studentApiRequest({
    url: `/go-peer/user-event?userId=${goPeerUserEvent.userId}&type=${goPeerUserEvent.type}`,
    method: "POST"
  });
};
function useSendGoPeerUserEvent() {
  return useMutation(
    "postGoPeerUserEvent",
    (goPeerUserEvent) => sendGoPeerUserEvent(goPeerUserEvent),
    {
      useErrorBoundary: false
    }
  );
}
const useGoPeerAvailabilityQuery = (subject) => {
  return useQuery(
    ["goPeerAvailability", subject],
    () => fetchGoPeerAvailability(subject),
    {
      useErrorBoundary: false
    }
  );
};
export {
  GoPeerUserType,
  useGoPeerAvailabilityQuery,
  useGoPeerTokenQuery,
  useSendGoPeerUserEvent
};
